<template>
  <div>
    <vue-headful :title="pageTitle"/>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'

export default {
  computed: {
    pageTitle () {
      return SettingsService.pageTitle('')
    }
  },
  created () {
    this.$router.replace({name: 'Login'})
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Index.vue